import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentModule } from 'ngx-moment';
import { OrderEditLogsComponent } from './order-edit-logs.component';

@NgModule({
  imports: [CommonModule, MomentModule],
  declarations: [OrderEditLogsComponent],
  exports: [OrderEditLogsComponent],
})
export class OrderEditLogsModule {}
